// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
exports.push([module.id, "@import url(https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/6.12.0/css/globals.css);"]);
// Module
exports.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"_flyout-vars.scss"}]);
// Exports
exports.locals = {
	"owcFlyoutAnimationTime": "300"
};
module.exports = exports;
